/* @flow */
import GroupActions from 'groups/actions/GroupActions';
import JoinInfoPageBirthdate from './JoinInfoPageBirthdate.jsx';
import JoinInfoPageCreateFullAccount from './JoinInfoPageCreateFullAccount.jsx';
import JoinInfoPageParentEmail from './JoinInfoPageParentEmail.jsx';
import JoinInfoPageRolePicker from './JoinInfoPageRolePicker.jsx';
import JoinPageLoadingIndicator from './JoinPageLoadingIndicator.jsx';
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
import PromptStore from 'stores/PromptStore';
import React from 'react';
import AuthActions from 'auth/AuthActions';
import User from 'entities/User';
import UserActions from 'user/UserActions';
import ToastActions from 'actions/ToastActions';

class JoinInfoPage extends React.Component {
  props: {
    onDone?: ?Function,
    params: Object,
    code?: ?string,
  }

  state: {
    status: 'loading' | 'gather_info',
    user: ?User,
  }

  state = {
    status: 'loading',
    user: null,
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  componentWillMount() {
    AuthActions.checkLoggedIn().then(user => {
      this.setState({ status: 'gather_info', user }, () => {
        if (!this.getNextNeed()) {
          this.onGatheredEverythingNeeded();
        }
      });
    }, () => {
      return this.context.router.push('/log_in');
    });
  }

  onError(response: any) {
    ToastActions.showAPIError(response);
  }

  onGatheredEverythingNeeded = () => {
    const groupCode = this.getGroupCode();

    // if there isn't a group code then we just bail out and
    // dont try to subscribe to a class.
    if (!groupCode) {
      // if callback in props parent will handle transition for us.
      if (this.props.onDone) {
        this.props.onDone();
        return;
      }

      this.context.router.push('/classes?origin=subscribed');
      return;
    }

    const onSuccess = () => {
      // bypass setup/subscription setup step.
      if (PromptStore.hasDismissed(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)) {
        UserActions.loadCurrentUser();
      } else {
        PromptActions.recordDismissal(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION).then(() => {
          UserActions.loadCurrentUser();
        })
        .catch(e => console.error('JoinInfoPage onSuccess failed', e));
      }

      // if callback in props parent will handle transition for us.
      if (this.props.onDone) {
        this.props.onDone();
        return;
      }

      this.context.router.push(`/classes/${groupCode}?origin=subscribed`);
    };

    const onError = (error) => {
      this.onError(error);
      this.context.router.push('/classes');
    };

    GroupActions.subscribeToGroupWithCode(groupCode).then(onSuccess, onError);
  }

  getGroupCode = () => {
    // XXX this component does too much
    return this.props.params.groupCode || this.props.code || null;
  }

  getNextNeed = () => {
    const { user } = this.state;

    const needs = user ? user.getNeeds() : {};

    /* All those components must accept a onDone props
     * that return the updated user object as well as an onError prop
     * that takes in an error response object. Order matters here.
     */
    const infos = [
      { when: needs.role, Component: JoinInfoPageRolePicker },
      { when: needs.birthdate, Component: JoinInfoPageBirthdate },
      { when: needs.parent_email, Component: JoinInfoPageParentEmail },
      { when: needs.password, Component: JoinInfoPageCreateFullAccount },
    ];

    return infos.find(info => info.when === true);
  }

  updateUser = (user: User) => {
    this.setState({ user }, () => {
      if (!this.getNextNeed()) {
        this.onGatheredEverythingNeeded();
      }
    });
  }

  renderInformationGathering() {
    const need = this.getNextNeed();

    if (!need) {
      return <JoinPageLoadingIndicator />;
    }

    return <need.Component onDone={this.updateUser} onError={this.onError} />;
  }

  renderLoading() {
    return <JoinPageLoadingIndicator />;
  }

  render() {
    if (this.state.status === 'loading') {
      return this.renderLoading();
    } else if (this.state.status === 'gather_info') {
      return this.renderInformationGathering();
    }
    return null;
  }
}

export default JoinInfoPage;



// WEBPACK FOOTER //
// ./src/join/components/JoinInfoPage.jsx